import { Injectable } from '@angular/core';
import { Observer,Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../_services/utils.service';

@Injectable({
    providedIn: 'root'
})

export class CardPaymentService {
    observer: Observer<number>;
    constructor(
        private _utilsService: UtilsService
    ){}
    
    addFunds(user_id,is_welcome=0) {
        let url = `${environment.phpApiUrl}` + '/cashier/add-funds/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + user_id;
        if(is_welcome) url = url+"?is_welcome="+is_welcome;
        return this._utilsService.getRequest(url);
    }

    checkPromoCode(data): Observable<any> {
        return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/check-promo-code', data, null, 'content-type-json');
    }

    checkPromoCodeByAmt(data): Observable<any> {
        return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/promocode/check', data, null, 'content-type-json');
    }

    ftpCard( data): Observable<any> {
        return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/add-new-funds', data, null, 'content-type-json');
    }

    saveCardPayment( data): Observable<any> {
        return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/cashier/add-amount', data, null, 'content-type-json');
    }
}
